import { render, staticRenderFns } from "./CaAlert.vue?vue&type=template&id=39e21db5&"
import script from "./CaAlert.vue?vue&type=script&lang=js&"
export * from "./CaAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports